import { getUserFacingErrorMessage, UserFacingError } from '@/lib/userFacingError';

/**
 * Medplum `auth/setpassword` 400 messages that are written for end users. Anchored at both ends so a
 * suffix appended by the server is not shown. The breached-password message is intentionally absent:
 * its exact text is not verified in this repo, so it falls back to the authored copy.
 */
const KNOWN_PASSWORD_POLICY_MESSAGES = [/^Invalid password, must be at least \d+ characters$/];

/** Text to show for a 400 from `auth/setpassword`: known policy messages in full, anything else hidden in production. */
export function getSetPasswordBadRequestMessage(err: unknown, message: string, isReset: boolean): string {
  const known = KNOWN_PASSWORD_POLICY_MESSAGES.some((re) => re.test(message));
  return getUserFacingErrorMessage(
    known ? new UserFacingError(message) : err,
    isReset
      ? "We couldn't reset your password. Please check it and try again."
      : "We couldn't activate your account. Please check your password and try again.",
  );
}
